import { useEffect } from "react"
import Container from "../components/core/Container"
import Nav from "../components/Nav"
import LandingBanner from "../components/home/LandingBanner"
import Services from "../components/home/Services"
import HowItWorks from "../components/home/HowItWorks"
import AboutUs from "../components/home/AboutUs"
import Team from "../components/home/Team"
import ContactForm from "../components/form/ContactForm"
import Footer from "../components/Footer"
import SEO from "../components/SEO"
import { sendContactUsEmail } from "../api/send/contact_us"
import SubscribeUs from "../components/emailing/SubscribeUs"
import { handleSubscribeUsSubmit } from "../handlers/handleSubcribeUsSubmit"
import InfoPopUp from "../components/pop_up/InfoPopUp"
import { useState } from "react"

export default function HomePage(){
    const [isInfoPopUpOpen, setIsInfoPopUpOpen] = useState(false);
    const [infoPopUpTitle, setInfoPopUpTitle] = useState("");
    const [infoPopUpText, setInfoPopUpText] = useState("");
    const [infoPopUpType, setInfoPopUpType] = useState("success");

    useEffect(() => {
        // Kontrola hash v URL při načtení stránky
        const hash = window.location.hash;
        if (hash === "#kontaktujte_nas") {
            setTimeout(() => {
                const element = document.getElementById("kontaktujte_nas");
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        }
    }, []);
    
    const handleSubscribeUsSubmitOverride = async (e) => {
        e.preventDefault();
        const formData = {
            email: e.target.email.value,
        }
        console.log(formData);
        try {
            const result = await handleSubscribeUsSubmit(formData);
            if (result.success) {
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("success");
            setInfoPopUpTitle("Odběr newsletteru byl úspěšně odeslán!");
            setInfoPopUpText("Odběr newsletteru byl úspěšně odeslán! Váš email bude v nejbližší době přidán do našeho newsletteru.");
            e.target.reset(); // Reset formuláře po úspěšném odběru
            } else {
                setIsInfoPopUpOpen(true);
                setInfoPopUpType("error");
                setInfoPopUpTitle("Nepodařilo se odeslat odběr newsletteru!");
                setInfoPopUpText(result.message);
            }
        } catch (error) {       
            console.error('Chyba při odběru newsletteru:', error);
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("error");
            setInfoPopUpTitle("Nepodařilo se odeslat odběr newsletteru!");
            setInfoPopUpText("Nepodařilo se odeslat odběr newsletteru. Zkuste to prosím znovu.");
        }
    }

    const handleContactUsSubmit = async (e) => {
        e.preventDefault();
    
        const formData = {
            name: e.target.name.value,
            surname: e.target.surname.value,
            company: e.target.company.value,
            email: e.target.email.value,
            phone: e.target.phone.value,
            message: e.target.message.value,
        }
        console.log(formData);
        try {
            await sendContactUsEmail(formData);
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("success");
            setInfoPopUpTitle("Zpráva byla úspěšně odeslána!");
            setInfoPopUpText("Zpráva byla úspěšně odeslána! V nejbližší době vás budeme kontaktovat na email nebo telefon s dalšími informacemi před samotnou realizací kurzu.");
            e.target.reset(); // Reset formuláře po úspěšném odeslání
        } catch (error) {
            setIsInfoPopUpOpen(true);
            setInfoPopUpType("error");
            setInfoPopUpTitle("Nepodařilo se odeslat zprávu!");
            setInfoPopUpText("Nepodařilo se odeslat zprávu. Zkuste to prosím znovu.");
        }
    }

    // Strukturovaná data pro homepage
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "EducationalOrganization",
        "name": "digibezstresu",
        "description": "Moderní vzdělávací platforma nabízející online a prezenční kurzy. Učte se bez stresu, digitálně a efektivně.",
        "url": process.env.REACT_APP_SITE_URL || "https://digibezstresu.cz",
        "logo": `${process.env.REACT_APP_SITE_URL || "https://digibezstresu.cz"}/logo500x500_transparent.png`,
        "sameAs": [],
        "contactPoint": {
            "@type": "ContactPoint",
            "contactType": "customer service",
            "availableLanguage": "Czech"
        }
    };

    return(
        <>
            <SEO
                title="digibezstresu - Digitální vzdělávání bez stresu"
                description="Moderní vzdělávací platforma nabízející online a prezenční kurzy. Učte se bez stresu, digitálně a efektivně. Objevte naši nabídku kurzů a začněte se vzdělávat ještě dnes."
                keywords="vzdělávání, kurzy, online kurzy, prezenční kurzy, digitální vzdělávání, vzdělávací platforma, bezstresové učení, efektivní vzdělávání"
                url="/"
                structuredData={structuredData}
            />
            <Container className="min-h-screen flex flex-col">
                <Nav/>
                <LandingBanner/>
            {/*<Stats/>* - statistiky*/}
            <Services/>
            <HowItWorks/>
            <AboutUs/>
            {/*<Testimonials/> - recenze*/}
            <Team/>
            {isInfoPopUpOpen && <InfoPopUp title={infoPopUpTitle} text={infoPopUpText} type={infoPopUpType} onClick={() => setIsInfoPopUpOpen(false)}/>}
            <ContactForm onSubmit={handleContactUsSubmit}/>
            <SubscribeUs onSubmit={handleSubscribeUsSubmitOverride}/>
            <Footer/>
        </Container>
        </>
    )
}